module.exports = __webpack_public_path__ + "img/gybg.f141c52b.png";